export default __webpack_public_path__ + "static/media/doc.5f12eeb0.svg";